import { Injectable } from '@angular/core';
import { CreateFichierOperationInput, FichierOperation, Operation } from '@lib/models/generated/graphql';
import { fichierOperationControlFragment } from '@lib/models/graphqlFragments';
import { QueryManagerService } from '@lib/services/queryManagerService';
import { gql } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';

const UPDATEFILE = gql`
  mutation updateFichierOperationFile($fichierOperationId: ID!, $fileId: String!) {
    updateFichierOperationFile(fichierOperationId: $fichierOperationId, fileId: $fileId) {
      ...fichierOperationControl
    }
  }
  ${fichierOperationControlFragment}
`;

const CREATEFICHIEROPERATION = gql`
  mutation createFichierOperation($input: CreateFichierOperationInput!) {
    createFichierOperation(input: $input) {
      ...fichierOperationControl
    }
  }
  ${fichierOperationControlFragment}
`;

const REMOVEFICHIEROPERATION = gql`
  mutation removeFichierOperationFromOperation($fichierOperationId: ID!) {
    removeFichierOperationFromOperation(fichierOperationId: $fichierOperationId) {
      id
      statut {
        id
        consultantLibelle
        backOfficeLibelle
      }
      activeOperationStateTransitionTriggers
      commentaireGestionnaire
      fichierOperations {
        ...fichierOperationControl
      }
    }
  }
  ${fichierOperationControlFragment}
`;

@Injectable({
  providedIn: 'root',
})
export class FichierOperationService {
  constructor(private queryManager: QueryManagerService) {}

  async createFichierOperation(
    fileId: string,
    operationId: number,
    forCoInvestisseur: boolean,
    commentaire?: string
  ): Promise<FichierOperation | undefined> {
    const input: CreateFichierOperationInput = {
      fileId: fileId,
      operationId: operationId,
      commentaire: commentaire,
      estHorsConfig: true,
      estCoInvestisseur: forCoInvestisseur,
    };

    const result = (
      await firstValueFrom(
        this.queryManager.mutate<{ createFichierOperation: FichierOperation }>({
          mutation: CREATEFICHIEROPERATION,
          variables: {
            input,
          },
        })
      )
    ).data?.createFichierOperation;
    return result;
  }

  async updatFileForFichierOperation(
    fichierOperationId: number,
    fileId: string
  ): Promise<FichierOperation | undefined> {
    if (!fichierOperationId || !fileId) {
      return;
    }
    const result = (
      await firstValueFrom(
        this.queryManager.mutate<{ updateFichierOperationFile: FichierOperation }>({
          mutation: UPDATEFILE,
          variables: {
            fichierOperationId,
            fileId,
          },
        })
      )
    ).data?.updateFichierOperationFile;
    return result;
  }

  async removeFichierOperationFromOperation(fichierOperationId: number): Promise<Operation | undefined> {
    const fromOperation = (
      await firstValueFrom(
        this.queryManager.mutate<{ removeFichierOperationFromOperation: Operation }>({
          mutation: REMOVEFICHIEROPERATION,
          variables: {
            fichierOperationId,
          },
        })
      )
    ).data?.removeFichierOperationFromOperation;
    return fromOperation;
  }
}
